import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { ScreenWidth } from 'web-common/src/shared/Constants';
import { Border, Colors, Spacing } from 'web-common/src/shared/styles';
import { PADDING, SEGMENT_DIVIDER_WIDTH, SHADOW_BREATHING_ROOM } from './consts';
import { ScrollButtons } from './ScrollButtons';

export const PositionedScrollButtons = styled(ScrollButtons)`
  position: absolute;
  top: 0;
  right: -60px; // Place off the edge
`;

export const SegmentDivider = styled.div`
  position: relative;
  left: 0;

  height: 0;
  width: ${SEGMENT_DIVIDER_WIDTH}px;
  border: ${Spacing.EIGHTH} solid ${Colors.JACKFRUIT_DARK_10};
  border-radius: ${Border.Radius.S};
`;

export const SegmentDividerContainer = styled.div<{ padding?: number }>`
  background: ${Colors.GRAY_LITE_20};
  position: absolute;
  bottom: -${Spacing.SINGLE_HALF};
  left: ${Spacing.SINGLE}; // Initial value (Same as container padding)

  height: ${Spacing.QUARTER};
  width: calc(100% - ${Spacing.DOUBLE});
  border-radius: ${Border.Radius.S};
  overflow: hidden;
`;

export const DefaultContainer = styled.div`
  width: 100%;
  ${minScreen(ScreenWidth.MEDIUM)} {
    width: calc(100% + ${SHADOW_BREATHING_ROOM * 2}px);
    margin-right: -${SHADOW_BREATHING_ROOM}px;
    margin-left: -${SHADOW_BREATHING_ROOM}px;
  }

  display: flex;
  align-items: stretch;
  justify-content: flex-start;

  overflow-x: scroll;
  overflow-y: clip;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  scroll-snap-type: x mandatory;
  scroll-padding-left: ${SHADOW_BREATHING_ROOM}px;
  & > * {
    scroll-snap-align: start;
  }
  @media (max-width: ${ScreenWidth.MEDIUM}) {
    scroll-padding-left: ${PADDING}px;
  }
  @media (max-width: ${ScreenWidth.SMALL}) {
    scroll-snap-type: none;
  }

  // Give box shadows breathing room at the bottom of this scrollable div
  padding-bottom: 50px;
  margin-bottom: -50px; // Prevent this from affecting anything outside the component

  & > * {
    opacity: 1;
    transition: opacity 0.11s ease-in-out;

    margin-right: ${Spacing.SINGLE};
    ${minScreen(ScreenWidth.SMALL)} {
      margin-right: ${Spacing.SINGLE_HALF};
    }

    box-shadow: 10px 16px 30px rgba(0, 0, 0, 0.1);
  }
  .offscreen {
    opacity: 0;
  }

  & > :first-child {
    margin-left: ${PADDING}px;
    ${minScreen(ScreenWidth.MEDIUM)} {
      margin-left: ${SHADOW_BREATHING_ROOM}px;
    }
  }
  & > :last-child {
    margin-right: ${PADDING}px;
    ${minScreen(ScreenWidth.MEDIUM)} {
      margin-right: ${SHADOW_BREATHING_ROOM}px;
    }
  }
`;
